import { Field, useFormikContext } from "formik";
import moment from "moment";
import { useFormInputHelpers } from "./useFormInputHelpers";
import { DayPickerCamvio } from "components";

const FormDateInput = ({
  name,
  onChange,
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  ...props
}) => {
  const { setFieldValue } = useFormikContext();

  const handleDateChange = (date) => {
    if (typeof onChange === "function") {
      onChange(date);
    } else {
      setFieldValue(name, date);
      // .then(() => {
      //   setTouched(name, true);
      // });
    }
  };

  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  return (
    <Field
      name={name}
      isError={shouldDisplayError}
      as={DayPickerCamvio}
      helperText={finalHelperText}
      onChange={handleDateChange}
      {...props}
    />
  );
};

export default FormDateInput;
